import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import GenericEventDates from "../../validation/GenericEventDates";
import { AppContext } from "../Redux/ContextProvider";
import { Link } from "react-router-dom";
import CustomButton from "../CustomButton";

function Preview({ handleStep, data }) {
  // console.log("preview", data);
  // const [showModal, setShowModal] = useState(false);
  const { appState, dispatch } = useContext(AppContext);
  const { registerEvent, registerEventLoader, registerEventMessage } = appState;

   const submitInfo = (action) => {
    handleStep([], action, "preview");
  };

  // const handleClose = () => {
  //   setShowModal(false);
  // };

  const [value, setValue] = useState({
    guestEvents: [],
    events: [],
  });

  useEffect(() => {

    const eventsList = data?.eventsList || [];

    const guestEventIds = data?.guestEventIds || [];

    const eventIds = data?.eventIds || [];

    //For Guest Events
    let guest = data.eventsList
      .filter((info) => data.guestEventIds.includes(info.event_id))
      .map((val) => val);

    let event = data.eventsList
      .filter((info) => data.eventIds.includes(info.event_id))
      .map((val) => val);

    setValue({
      ...value,
      guestEvents: guest,
      events: event,
    });
  }, [
    data?.eventsList,
    data?.guestEventIds,
    data?.eventIds,
  ]);

   const getEventWholesalers = (eventId) => {
    // ADD: support eventWholesalers object
    if (
      data?.eventWholesalers &&
      data.eventWholesalers[eventId]
    ) {
      return data.eventWholesalers[eventId];
    }

    // ADD: fallback to existing wholesalerlist
    return (
      data?.wholesalerlist?.filter(
        (item) => item.event_id === eventId
      ) || []
    );
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-6 col-sm-6 col-12">
        <div className="glass-effect space">
          <div className="mb-10">
            <h2>Preview Information:</h2>
          </div>
          <hr />
          <div>
            <div className="mt-20">
              <h5 className="title">Email:</h5>
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="form-inner">
                    <input type="text" value={data.email} disabled />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-20">
              <h5 className="title">Information:</h5>
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="form-inner">
                    <input type="text" value={data.fname} disabled />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-inner">
                    <input type="text" value={data.lname} disabled />
                  </div>
                </div>
                {data.company !== "" && (
                  <div className="col-lg-6">
                    <div className="form-inner">
                      <input type="text" value={data.company} disabled />
                    </div>
                  </div>
                )}
                <div className="col-lg-6">
                  <div className="form-inner">
                    <input type="text" value={data.address} disabled />
                  </div>
                </div>
                {data.mobile && (
                  <div className="col-lg-6">
                    <div className="form-inner">
                      <input type="text" value={data.mobile} disabled />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {data.jobtitle ? <div className="mt-20">
              <h5 className="title">Job Title:</h5>
              <div className="row g-4">
                <div className="col-lg-12">
                  <div className="form-inner">
                    <input
                      type="text"
                      value={data.jobtitle}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </div> : null}
            {data.foodAllergy ? <div className="mt-20">
              <h5 className="title">Food Allergy:</h5>
              <div className="row g-4">
                <div className="col-lg-12">
                  <div className="form-inner">
                    <input
                      type="text"
                      value={data.foodAllergy}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </div> : null}
            <div className="mt-20">
              <h5 className="title">Package:</h5>
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="form-inner">
                    <input
                      type="text"
                      value={data.selectedTypeName}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-inner">
                    <input
                      type="text"
                      value={data.selectedSubTypeName}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            {data.selectedTypeName === "Sponsor" && (
              <div className="mt-20">
                <h5 className="title">Benefits Included:</h5>
                <span className="textarea">
                  {data.optionsList.map((val) => {
                    return (
                      <label className="textarea-content" disabled={true}>
                        {val.title}
                      </label>
                    );
                  })}
                </span>
              </div>
            )}
            {data.selectedTypeName === "Sponsor" && (
              <div className="mt-20">
                <h5 className="title">Bonus Options Included:</h5>
                <span className="textarea">
                  {data.option
                    .sort((a, b) => a.order_by - b.order_by)
                    .filter((info) =>
                      data.selectedList.includes(info.sponsors_bonus_option_id)
                    )
                    .map((val) => {
                      return (
                        <label className="textarea-content" disabled={true}>
                          {val.title}
                        </label>
                      );
                    })}
                </span>
              </div>
            )}

            {data.selectedSubTypeName !== "Non-attending" && (
              <div className="mt-20">
                <h5 className="title">Events Attending:</h5>
                <GenericEventDates
                  component={false}
                  selectedEvent={value.events}
                  ids={data?.eventIds || []}
                />
              </div>
            )}

             {value.events.some((each) => each.wholesaler_list.length > 0) &&
            data.wholesalerlist &&
            data.wholesalerlist.length > 0 && (
              <div className="mt-20 row">
                <h5 className="title">Wholesalers Events Attending:</h5>
                {/* <li style={{
                                listStyle: 'none', margin: '10 auto', boxShadow: '0 0 0 1px rgb(0 0 0 / 13%)',
                                width: '50%',
                                background: '#fff',
                                overflow: 'hidden',
                                borderRadius: '0.2rem',
                                padding: '15px 14px',
                                textAlign: 'left',
                                verticalAlign: 'center'

                            }}>
                                <label style={{ wordWraprap: 'break-word' }}>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock-fill" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                    </svg>  Selected Time Slot: {data.time_slot}
                                </label>
                            </li> */}
                <Row>
                  {value.events.map((event, eventIndex) => {
                    const wholesalers = getEventWholesalers(
                      event.event_id
                    );

                    if (wholesalers.length === 0) {
                      return null;
                    }

                    return (
                      <div
                        style={{
                          marginBottom: "20px",
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          padding: "15px 15px 0",
                          background: "#fff",
                        }}
                      >
                        <Col
                          xs="12"
                          key={event.event_id || eventIndex}
                          style={{ textAlign: "left" }}
                        >
                          <h5
                            className="title"
                            style={{
                              marginBottom: "10px",
                            }}
                          >
                            {event.event_name}
                          </h5>

                          <Row>
                            {wholesalers.map((wholesaler, idx) => {
                              return (
                                <Col
                                  xs="12"
                                  sm="6"
                                  key={
                                    wholesaler?.customer_id ||
                                    wholesaler?.id ||
                                    idx
                                  }
                                  style={{
                                    textAlign: "left",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <li
                                    style={{
                                      listStyle: "none",
                                      margin: "0 auto",
                                      boxShadow:
                                        "0 0 0 1px rgb(0 0 0 / 13%)",
                                      width: "100%",
                                      height: "100%",
                                      background: "#fff",
                                      overflow: "hidden",
                                      borderRadius: "0.2rem",
                                      padding: "15px 14px",
                                    }}
                                  >
                                    <label
                                      style={{
                                        wordWrap: "break-word",
                                      }}
                                    >
                                         <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" /><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 2a1 1 0 0 1 .993.883L13 7v4.586l2.707 2.707a1 1 0 0 1-1.32 1.497l-.094-.083l-3-3a1 1 0 0 1-.284-.576L11 12V7a1 1 0 0 1 1-1" /></g></svg>
                                         {" "}
                                      {wholesaler.timeslot}{" "}
                                      {wholesaler.name}
                                      {wholesaler.executive_name && (
                                        <>
                                          {" - "}
                                          Executive:{" "}
                                          {wholesaler.executive_name}
                                        </>
                                      )}
                                    </label>
                                  </li>
                                </Col>
                              );
                            })}
                          </Row>
                        </Col>
                      </div>
                    );
                  })}
                </Row>
              </div>
            )}
            {data.guest && data.guestFname !== "" && (
              <div className="mt-20">
                <h5 className="title">Guest:</h5>
                <div className="row g-4">
                  <div className="col-lg-6">
                    <div className="form-inner">
                      <input
                        type="text"
                        value={data.guestFname}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-inner">
                      <input type="text" value={data.guestLname} disabled />
                    </div>
                  </div>
                  {data.guestMobile && (
                    <div className="col-lg-6">
                      <div className="form-inner">
                        <input type="text" value={data.guestMobile} disabled />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {data.guestEventIds && data.guestEventIds.length > 0 && (
              <div className="mt-20">
                <h5 className="title">Guest Event Attending:</h5>
                <GenericEventDates
                  component={false}
                  selectedEvent={value.guestEvents}
                  ids={data?.guestEventIds || []}
                />
              </div>
            )}
          </div>
          <div className="arrow-container">
            {registerEventLoader ? (
              <div className="mt-20">
                <ClipLoader color={"#2A5350"} loading={true} size={50} />
              </div>
            ) : (
              <>
                <button className="eg-btn btn--primary2 capsule mt-20 prev" onClick={() => submitInfo("previous")} >
                 <CustomButton /> Prev
                </button>
                <button className="eg-btn btn--primary2 capsule mt-20"
                  onClick={() => {
                    submitInfo("next");
                    // setShowModal(true);
                  }}
                >
                  Finish Registration<CustomButton />
                </button>
                {/* <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Confirmation</Modal.Title>
                  <Modal.Body>
                    <h4>want to book the rooms ?</h4>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button>Confirm</Button>
                    <Button onClick={handleClose}>
                      <Link to="/login">Cancel</Link>
                    </Button>
                  </Modal.Footer>
                </Modal.Header>
              </Modal> */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Preview;
